<template>
    <div>
        <stepper-toolbar :no-register="userFinished" :no-slug="!slug" :current-step="step"/>
        <v-container class="my-5">
            <v-row>
                <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
                    <v-slide-y-transition>
                        <client-entity-selector v-if="!slug" v-show="step === 1" @success="onSuccessEntity"/>
                    </v-slide-y-transition>
                    <v-slide-y-transition>
                        <client-profile-selector v-show="step === 2" @success="onSuccessProfile"/>
                    </v-slide-y-transition>
                    <v-slide-y-transition>
                        <client-packs-selector
                            v-show="step === 3"
                            @success="onSuccessPacks"
                            @back="step--"
                            :current-packs="packs"
                        />
                    </v-slide-y-transition>
                    <v-slide-y-transition>
                        <client-resume-stepper
                            v-show="step === 4"
                            @success="onSuccessResume"
                            :exams="packs"
                            @back="step--"
                        />
                    </v-slide-y-transition>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import StepperToolbar from "@/components/client/StepperToolbar";
import ClientProfileSelector from "@/components/client/ClientProfileSelector";
import ClientExamsSelector from "@/components/client/ClientExamsSelector";
import ClientPacksSelector from "@/components/client/ClientPacksSelector";
import httpService from "@/services/httpService";
import ClientResumeStepper from "@/components/client/ClientResumeStepper";
import {STATUS} from "@/utils/Constants";
import ClientEntitySelector from "@/components/client/ClientEntitySelector";

export default {
    name: "ClientStepper",
    components: {
        ClientEntitySelector,
        ClientResumeStepper, ClientPacksSelector, ClientExamsSelector, ClientProfileSelector, StepperToolbar},
    data() {
        return {
            step: 1,
            packs: [],
            entitySelected: null,
        }
    },
    computed: {
        userFinished(vm = this) {
            return vm.currentUser?.status_id === STATUS.USER_FINISHED
        },
        slug(vm = this) {
            return vm.$route.query.slug || null
        },
        entityId(vm = this) {
            if (vm.entitySelected) return vm.entitySelected
            let firstClientOf = JSON.parse(vm.currentUser?.client_of || '[null]')?.[0]
            if (!vm.userFinished) return firstClientOf
            return vm.slug
        }
    },
    async mounted() {
        const vm = this
        if (vm.slug) {
            vm.step = 2
            await vm.loadEntity()
        }
    },
    methods: {
        onSuccessEntity(entity) {
            const vm = this
            vm.entitySelected = entity || null
            vm.loadEntity()
            vm.step = 2
        },
        async onSuccessProfile() {
            const vm = this
            vm.step = 3
        },
        onSuccessPacks(packs) {
            const vm = this
            if (packs.length === 0) return vm.toast('No ha seleccionado aun examenes', 'error')
            vm.packs = packs
            vm.step = 4
        },
        onSuccessResume() {
            const vm = this
            vm.toast('Se ha enviado su orden')
            vm.$router.push({name: 'home'})
        },
        async loadEntity() {
            const vm = this
            if (vm.entitySelected) {
                vm.setCurrentEntity(vm.entitySelected)
            } else {
                let url = vm.slug ? `laboratories/slug/${vm.entityId}` : `laboratories/${vm.entityId}`
                let response = await httpService.get(url)
                vm.setCurrentEntity(response.data.laboratory)
            }
        },
    },
    watch: {
        step() {
            this.$vuetify.goTo(0)
        }
    }
}
</script>

<style scoped>

</style>